<template>
    <div id="resume">
        <v-layout row wrap>
            <v-flex xs12 sm6 pr-3>
            
            <v-card>
                <v-card-text>
                    <h3 class="title my-4">Освіта:</h3>
                        <ul>
                            <li>2001 - здобула кваліфікацію "Артист-Вокаліст". 
                                <br>Диплом бакалавра з відзнакою 
                                <br>(Державний Музичний Коледж ім.С.Людкевича)</li>
                            <li>2006 - здобула кваліфікацію "Акторка Драматичного Театру і Кіно"<br> 
                                Повна вища освіта за спеціальністю "Театральне мистецтво"<br>
                                Диплом з відзнакою <br> (Львівський Національний Університет ім. І.Франка )</li>
                        </ul>                    
                </v-card-text>
            </v-card>


<v-card class="mt-2">
    <v-card-text>
        <h3 class="title my-4">Професійна діяльність:</h3>
            <p>2019 - засновник, викладач вокалу і майстерності актора в "Coach Performing Arts Academy" (Північна Кароліна, США)</p>
            <!-- <p>2019 - режисер, викладач майстерності актора та вокалу в "Мистецькій школі Кіно" (Шарлотт, Північна Кароліна, США)</p> -->
            <p>2018-2019 - викладач вокалу та режисер дитячого музичного театру в школі мистецтв "Віртуози"</p>
            <p>(Баллантайн, Північна Кароліна, США)</p>
            <p>З 2009 - free lance aкторка і співачка</p>
            <p>2014-2016 - організатор та учасник музично-театральних програм:</p>
                <ul>
                    <li>концерти присвячені творчості Івана Франка</li>
                    <li>концерти присвячені творчості Тараса Шевченка</li>   
                    <li>концерти присвячені творчості Василя Симоненка</li>    
                    <li>концерти присвячені творчості Ліни Костенко</li>
                    <li>концерти присвячені творчості Лесі Українки</li>
                    <li>авторський концерт "Слово, моя ти єдиная зброє!"</li>   
                    <li>актриса, співачка, режисер та ведуча заходу "Герої не вмирають!" (Львівська Національна Філармонія)</li>
                    <li>музично-театральний проект "8 ЖІНОК" (театр "Сузір'я", Киів )</li>                                
                </ul>

            <p>2012-2013 - участь у музично-театральних концертах "Софійській Собор" (Киів, Україна)</p>
            <p>2012 - оперна студія Національної Музичної Академії ім.П.Чайковського (Киів)</p>
                <ul>
                    <li>головна роль Марії у експериментальній комічній опері "Граф Каліостро" (М. Л.Таривердієва)</li>
                </ul>

            <p>2003-2010 - Львівський Академічний Театр "Воскресіння"</p>
            <ul>
                <li>головна роль Мавки у музично-драматичній виставі "Я маю в серці те, що не вмирає" (Леся Українка) </li>
                <li>головна роль Лікаря у драматичній виставі "Полковник і птахи" (Христо Бочев)</li>
                <li>роль Тітч (2 склад) "Полковник і Птахи"</li>
                <li>роль Валентини Андронівни у драматичній виставі "Завтра була війна" (Борис Васильєв)</li>                
            </ul>

            <p>2007-2008 - театр "Дзеркало" (Киів)</p>
                <ul>
                    <li>головна роль Снігуроньки у музично-драматичній виставі "Різдвяна Подорож на Чумацький Шлях"</li>
                    <li>роль Няні у драматичній виставі "Вій"</li>
                </ul>

            <p>2008 - радіоведуча прямого ефіру "Знакова постать"  Національна Телерадіокомпанія України (Киів)</p>
            <p>2007 - 2008–ведуча прямого ефіру на радіо "Мелодія", "Шарманка" (Киів)</p>

    </v-card-text>
</v-card>



    </v-flex>
    <v-flex xs12 sm6>
        <h3>Сповідь Мавки, драма Лесі Українки "Лісова пісня"</h3>
            <p class="font-style-italic">Виконує Оксана Ковч<br>
                                             Запис виконано на "Videostudio A. T.". Lviv, 2013</p>
                <iframe width="100%" height="350" src="//www.youtube.com/embed/fFjvHTeRxIQ" frameborder="0" allowfullscreen=""></iframe>
            <v-card>
                <v-card-title>
                    <div class="title mt-4">STUDIO CONTACT INFORMATION:</div>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap class="mb-4">
                        <v-flex xs12 sm6>
                            <h2 class="studio success--text ">"Videostudio A. T."</h2>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <h2 class="mt-14"><a href="http://www.hlynskyi.com.ua/" target="_blank">Website</a></h2>
                        </v-flex>
                    </v-layout>   
                </v-card-text>
            </v-card>
<v-card class="mt-2">
    <v-card-text> 
        <h3 class="title my-4">Кіно:</h3>
        <ul>
            <li>головна роль Людмили у документальному фільмі "Особова справа" (телеканал "Інтер", Киів)</li>
            <li>головна роль Мавки у музично-драматичному фільмі "Я маю в серці те, що не вмирає" (Львівське Телебачення)</li>
            <li>епізодична роль у фільмі "Владика Андрей" О.Янчук (кіностудія ім.О. Довженка)</li>
            <li>телереклами</li>
        </ul>
    </v-card-text>
</v-card>

    <v-card class="mt-2">
        <v-card-text> 
            <h3 class="title my-4">Відзнаки:</h3>
            <p>2015 - нагороджена медаллю «За жертовність і любов до України» за волонтерський культурний внесок в українське мистецтво</p>
            <p>2009 - лауреат Всеукраїнського конкурсу читців поезії Т.Г.Шевченка (Киів)</p>
            <p>2007 - участь у міжнародному фестивалі "SASIEDZI" (Польща). Вистава "Я маю в серці те, що не вмирає" - роль Мавки, увійшла в п'ятірку кращих.</p>
            <p>2006 - "Золота Медаль" Лауреат I-ї премії за участь у "Мистецькому конкурсі Львову-750" (Львів, Україна)</p>
            <p>2005 - участь у міжнародному театральному фестивалі "Подіум-2005" (Москва, Росія)</p>           
    </v-card-text>
</v-card>       
    
    <v-card class="mt-2">
        <v-card-text> 
            <h3 class="title my-4">Участь у розвитку дитячих талантiв:</h3>
                <p>2007-2009, 2015 - почесний гість, член журі, тренер на літературно-мистецькому фестивалі "Переяславська осінь Кобзаря" (Україна)</p>
                <p>2016 - голова журі конкурсу читців поезії ім. Лесі Українки (Киів)</p>  
                <p>2016 - член журі, почесний гість на конкурсі читців поезії ім.Максима Рильського (Киів)</p>
                <p>З 2018 - викладач вокалу і майстерності актора, режисер дитячих музично-театральних програм (Шарлотт, США)</p>            
        </v-card-text>
    </v-card>   
 
                <v-card class="mt-2 pb-63">
                    <v-card-text> 
                        <h3 class="title my-4">Мови:</h3>
                        <ul>
                            <li>Українська (рiдна)</li>
                            <li>Російська</li>
                            <li>Англiйська</li>
                        </ul>            
                    </v-card-text>
                </v-card>   
            </v-flex>            
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: 'Resume_UA',
        data: () => ({

        })
    }
</script>

<style>
    .mt-14 {
        margin-top: 14px;
    }
    .pb-63 {
        padding-bottom: 63px;
    }
</style>



